import {GetterTree} from 'vuex'
import {IEmployeesStateModel, IRootStateModel} from './../../../interfaces'
import {CompanyEmployeeModel, CompanyEmployeesListFilterModel, StatusType} from '@/services/types'

export type EmployeesGetters = {
    getEmployeesList(state: IEmployeesStateModel): CompanyEmployeeModel [];
    getEmployeesTotal(state: IEmployeesStateModel): number;
    isEmployeesDataLoading(state: IEmployeesStateModel): boolean;
    getEmployeesFilterValue(state: IEmployeesStateModel): CompanyEmployeesListFilterModel;
    getEmployeesSelectedEmployee(state: IEmployeesStateModel): CompanyEmployeeModel;
    getEmployeesErrorMessage(state: IEmployeesStateModel): string;
}

const filterByName = (search: string, list: CompanyEmployeeModel []): CompanyEmployeeModel [] => {
    if (search.length >=2) {
      return list.filter(item => {
          const name = `${item.lastname} ${item.firstname} ${item.surname}`
          return name.trim().toLowerCase().indexOf(search.trim().toLowerCase()) >= 0
      })
    }
    else {
      return list
    }
}

const filterByStatus = (status: StatusType, list: CompanyEmployeeModel []): CompanyEmployeeModel [] => {
    if (status !== null) {
        return list.filter(item => item.status === status)
    }
    else {
        return list
    }
}

// const filterByRoles = (roles: EmployeeRole [], list: CompanyEmployeeModel []): CompanyEmployeeModel [] => {
//     if (roles.length > 0) {
//         return list.filter(item => roles.indexOf(item.role) >= 0)
//     }
//     else {
//         return list
//     }
// }

export const getters: GetterTree<IEmployeesStateModel, IRootStateModel> & EmployeesGetters = {
    getEmployeesList: (state: IEmployeesStateModel) => {
        return state.list
    },
    getEmployeesTotal: (state: IEmployeesStateModel) => {
        return state.list.length
    },
    isEmployeesDataLoading: (state: IEmployeesStateModel) => {
        return state.dataIsLoading
    },
    getEmployeesSelectedEmployee: (state: IEmployeesStateModel) => {
        return state.selectedEmployee
    },
    getEmployeesFilterValue: (state: IEmployeesStateModel) => {
        return state.filter
    },
    getEmployeesFilteredList: (state: IEmployeesStateModel) => {
        //const roles = state.filter ? state.filter.roles : []
        const status = state.filter ? state.filter.status : null
        const search = state.filter ? state.filter.search : ''

        // return filterByRoles(roles, 
        //     filterByStatus(status, 
        //             filterByName(search, state.list)
        //         )
        // )
        return filterByStatus(status, 
            filterByName(search, state.list)
        )
    },
    getEmployeesErrorMessage: (state: IEmployeesStateModel) => {
        return state.error
    },
}
